import React, { useEffect, useState } from "react";
import { CheckCircle2Icon, Clock3Icon, FileTextIcon, GiftIcon, ShieldCheckIcon, SparklesIcon } from "lucide-react";
const PURCHASE_URL = "https://ebookpoint.shop/cart/50274132689148:1";
type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};
const orderItems = [{
  icon: FileTextIcon,
  label: "Manuale del Mediano Moderno",
  note: "8 moduli · oltre 480 pagine in PDF",
  value: "€58,99"
}, {
  icon: GiftIcon,
  label: "Atlante visuale del 5 moderno",
  note: "Mappe, coperture e movimenti",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "30 esercizi specifici per mediani",
  note: "Tecnica, pressione, duelli e letture",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "Piano fisico di 8 settimane",
  note: "Forza, velocità, resistenza e recupero",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "Scheda di analisi partita",
  note: "Dati, coperture e decisioni chiave",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "Guida ai mediani professionisti",
  note: "Studio e applicazione dei migliori",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "Tomo speciale: Il sistema completo dei passaggi",
  note: "Linee, tempi e soluzioni per progredire",
  value: "INCLUSO"
}, {
  icon: GiftIcon,
  label: "Tomo speciale: Velocità del mediano",
  note: "Accelerazione, reattività e cambi di direzione",
  value: "INCLUSO"
}];
export function CountdownOffer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 2,
    minutes: 17,
    seconds: 43
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        if (current.seconds > 0) return {
          ...current,
          seconds: current.seconds - 1
        };
        if (current.minutes > 0) return {
          ...current,
          minutes: current.minutes - 1,
          seconds: 59
        };
        if (current.hours > 0) return {
          hours: current.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return current;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formatted = (value: number) => value.toString().padStart(2, "0");
  return <section id="compra" className="scroll-mt-6 rounded-3xl border border-lime-300/40 bg-[#0b1611] p-5 shadow-[0_0_50px_rgba(145,207,43,0.14)]" data-id="element-104" data-mp="3f0akw0hh7nsh">
      <div className="flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.18em] text-lime-300" data-id="element-105" data-mp="3o1i89nigf47s"><Clock3Icon className="h-4 w-4" data-id="element-106" data-mp="3t0v1qr3tz9jc" /> Offerta di oggi</div>
      <h2 className="mt-4 text-3xl font-black uppercase italic leading-[0.92] text-white" data-id="element-107" data-mp="3sy8tsqd12s0l">Il tuo kit completo<br data-id="element-108" data-mp="2w89co7ital6e" /><span className="text-lime-300" data-id="element-109" data-mp="2w89dg9qmyp7g">per dominare il centrocampo.</span></h2>
      <p className="mt-3 text-sm leading-6 text-slate-300" data-id="element-110" data-mp="30bxkmrbcvis6">Un sistema pratico per leggere prima, coprire meglio e decidere con lucidità per tutti i 90 minuti.</p>

      <div className="mt-5 rounded-2xl border border-white/10 bg-black/35 p-4" data-id="element-111" data-mp="3a2itd7kqu3ot">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-wider text-slate-400" data-id="element-112" data-mp="2cmms1x45sup4">L’offerta termina tra</p>
        <div className="mt-3 grid grid-cols-3 gap-2 text-center" data-id="element-113" data-mp="2hjvcy5gozcu2">
          {[[timeLeft.hours, "ore"], [timeLeft.minutes, "min"], [timeLeft.seconds, "sec"]].map(([value, label]) => <div key={label as string} className="rounded-xl bg-white/10 py-2" data-id="element-114" data-mp="252atq1hw53ms"><div className="text-2xl font-black tabular-nums text-white" data-id="element-115" data-mp="203hcpz3eauhv">{formatted(value as number)}</div><div className="text-[10px] font-bold uppercase text-lime-300" data-id="element-116" data-mp="205by1eikwomh">{label as string}</div></div>)}
        </div>
      </div>

      <div className="mt-5 overflow-hidden rounded-2xl bg-white text-slate-950" data-id="element-117" data-mp="1r3unebnxxf56">
        <div className="flex items-center justify-between bg-slate-950 px-4 py-3 text-white" data-id="element-118" data-mp="1mbko450xr2q8">
          <div data-id="element-119" data-mp="1hcghnm5ebj3l"><p className="text-xs font-bold uppercase tracking-widest text-lime-300" data-id="element-120" data-mp="1hcgitph4tp56">Riepilogo del tuo ordine</p><p className="mt-0.5 text-xs text-slate-300" data-id="element-121" data-mp="1ceex0wsbnbq0">Tutto il necessario, in un unico accesso.</p></div>
          <SparklesIcon className="h-5 w-5 text-lime-300" data-id="element-122" data-mp="18cl0n0p5stvn" />
        </div>
        <div className="divide-y divide-slate-100 px-4" data-id="element-123" data-mp="13d8deeudlksj">
          {orderItems.map(item => {
          const Icon = item.icon;
          return <div key={item.label} className="flex gap-3 py-3" data-id="element-124" data-mp="33fzu5t1lnjxn">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" data-id="element-125" data-mp="37hbb7a6eqwu8" />
                <div className="min-w-0 flex-1" data-id="element-126" data-mp="2tpoi1j7ri4fo"><p className="text-sm font-bold leading-5" data-id="element-127" data-mp="2tolp75qvprx4">{item.label}</p><p className="mt-0.5 text-xs leading-4 text-slate-500" data-id="element-128" data-mp="2tnu1eh3iwyhe">{item.note}</p></div>
                <span className={`shrink-0 self-start text-[11px] font-black ${item.value === "INCLUSO" ? "text-green-700" : "text-slate-700"}`} data-id="element-129" data-mp="2ymet1s4pm9u8">{item.value}</span>
              </div>;
        })}
        </div>
        <div className="border-t border-slate-200 bg-lime-50 px-4 py-3" data-id="element-130" data-mp="2ar2elxorw18l"><p className="flex items-center justify-between text-sm font-bold" data-id="element-131" data-mp="2asnb3sundu93"><span data-id="element-132" data-mp="2fqx1zr9ca8ow">Consegna digitale</span><span className="text-green-700" data-id="element-133" data-mp="2fq5ihet0o1ez">Immediata</span></p></div>
      </div>

      <div className="mt-5 rounded-2xl border border-lime-300/30 bg-lime-300/10 p-4" data-id="element-134" data-mp="90qw2999u29k">
        <div className="flex items-end justify-between gap-3" data-id="element-135" data-mp="dxhbqvh5yvug"><div data-id="element-136" data-mp="dw694yzgfu4x"><p className="text-xs font-bold uppercase tracking-wider text-lime-200" data-id="element-137" data-mp="o2gz0bmo3iy1">Prezzo di listino</p><p className="mt-1 text-lg font-bold text-slate-400 line-through" data-id="element-138" data-mp="o033y2rzm6qh">€58,99</p></div><div className="text-right" data-id="element-139" data-mp="j57bj1iu9hcu"><p className="text-xs font-bold uppercase tracking-wider text-lime-200" data-id="element-140" data-mp="wurarxd7nwhe">Oggi paghi</p><p className="mt-1 text-4xl font-black text-white" data-id="element-141" data-mp="wwlwhdwb3smj">€19,90</p></div></div>
        <div className="mt-3 flex items-center gap-2 border-t border-lime-200/20 pt-3 text-sm font-bold text-lime-200" data-id="element-142" data-mp="s2recewcnlpk"><CheckCircle2Icon className="h-4 w-4" data-id="element-143" data-mp="16v1mteniexuz" /> Risparmi €39,09 e ricevi 5 bonus + 2 tomi speciali inclusi</div>
      </div>

      <div className="mt-5" data-id="element-144" data-mp="1ftdbhb4tflks"><p className="mb-2 text-center text-xs font-bold text-slate-300" data-id="element-145" data-mp="1ftwtssydobzc"><span className="text-lime-300" data-id="element-146" data-mp="1franewn842ip">940 posti di lancio</span> ancora disponibili</p><div className="h-2 overflow-hidden rounded-full bg-white/10" data-id="element-147" data-mp="1bsti8ind523x"><div className="h-full w-[68%] rounded-full bg-lime-300" data-id="element-148" data-mp="3hm1i7ugo4r5b" /></div></div>
      <a href={PURCHASE_URL} className="mt-5 flex min-h-14 w-full items-center justify-center rounded-xl bg-lime-300 px-4 text-center text-base font-black uppercase tracking-tight text-[#0c150f] transition-transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-lime-100" data-id="element-149" data-mp="3djogdh51lddt">Sì, voglio il kit completo</a>
      <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-xs text-slate-400" data-id="element-150" data-mp="1qgosg0k09bco"><ShieldCheckIcon className="h-4 w-4 text-lime-300" data-id="element-151" data-mp="1vgb80gnb33on" /> Pagamento sicuro · PDF disponibile subito</p>
    </section>;
}